import { render, staticRenderFns } from "./HerdSettings.vue?vue&type=template&id=6cb01709&"
import script from "./HerdSettings.vue?vue&type=script&lang=js&"
export * from "./HerdSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports